module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('div', {
    staticClass: "wrap-blue banner-with-copy"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6 col-md-push-6  pic"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner2_400.jpg",
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner2_600.jpg",
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner2_800.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner2_1000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/about/banner2_800.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "overlay"
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-6 col-md-pull-6 banner-content-wrap"
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            We are truly a learning company inside and out! Our goal is to provide the best learning resources and never stop improving, just like the learners we serve. Our ongoing research and development will ensure we deliver the tools that best serve your needs.\n          ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank xs-full-width",
    attrs: {
      "to": {
        name: 'features'
      }
    }
  }, [_vm._v("Learn More")])], 1)])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "container ptb-100"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
    staticClass: "hidden-xs col-sm-3"
  }, [_vm._c('VerticalAd', {
    attrs: {
      "containerClass": ''
    }
  })], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "row hidden visible-xs"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('HorizontalAd', {
    attrs: {
      "containerClass": ''
    }
  })], 1)])]), _vm._v(" "), _vm._c('div', {
    staticClass: "wrap-black banner-with-copy bottom-banner"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 pic"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner3_400.jpg",
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner3_600.jpg",
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner3_800.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/about/banner3_1000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/about/banner3_800.jpg",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._c('div', {
    staticClass: "container ptb-100"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _vm._c('div', {
    staticClass: "hidden-xs col-sm-3"
  }, [_vm._c('VerticalAd', {
    attrs: {
      "containerClass": ''
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "row hidden visible-xs"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('HorizontalAd', {
    attrs: {
      "containerClass": ''
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('h1', [_vm._v("Together "), _vm._c('br'), _vm._v("We Learn")])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-sm-9 large-text"
  }, [_vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n          CLEX stands for "), _vm._c('strong', [_vm._v("Contextual Learning Experience")]), _vm._v(". True to our name, CLEX Software is a web-based study tool dedicated to improving an individual’s capacity for learning by utilizing an individually optimized methodology to maximize each user’s studying potential.\n          We allows learners to organize study materials into micro-notes, identify keywords in their lessons, and prioritize what you need to study.\n        ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n          CLEX is all about bringing learners together through study communities.\n        ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n          We give you the ability to challenge yourself using individualized study levels, that you can control. It's our mission that as learners advance through their studies, their confidence grows. CLEX combines content from multiple sources into organized modules and it’s accessible anywhere you go.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._c('p', {
    staticClass: "x-large-text"
  }, [_vm._v("\n            CLEX offers a "), _vm._c('strong', [_vm._v("FREE")]), _vm._v(" study service that is results oriented for all students.\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n          CLEX is aware that the cost of post secondary education is very expensive and in order to make your life as stress free as possible, we are giving you CLEX for free at no charge with no obligation to purchase for as long as you need it. No three month trial like most service providers.\n        ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n          CLEX PLUS will offer students the option to purchase additional learning modules, that will help provide further learning support on top of CLEX. It is our intention to keep our learning module prices as low as possible, no more than the cost of a hamburger.\n        ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n          Should you purchase a module or two from us, "), _vm._c('strong', [_vm._v("CLEX will still remain free to use at all times")]), _vm._v(".\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10972a7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/AboutUsPage.vue
// module id = 622
// module chunks = 1